import { ExternalStakeholder } from './external-stakeholders-constants';

const RELATIONSHIP_RANK_ORDER = ['Primary POC', 'Secondary POC', 'Day-to-day contact'] as const;

// Unrecognised and null relationships sort after the ranked set.
const relationshipRank = (relationship: string | null): number => {
  const index = RELATIONSHIP_RANK_ORDER.findIndex(rank => rank === relationship);
  return index === -1 ? RELATIONSHIP_RANK_ORDER.length : index;
};

export const orderExternalStakeholders = (
  stakeholders: ExternalStakeholder[]
): ExternalStakeholder[] =>
  [...stakeholders].sort((a, b) => {
    const rankDelta = relationshipRank(a.relationship) - relationshipRank(b.relationship);
    return rankDelta === 0 ? a.name.localeCompare(b.name) : rankDelta;
  });

export const EMPTY_CELL = '—';

export const cellText = (value: string | null): string => value?.trim() || EMPTY_CELL;

export const presentItems = (values: string[]): string[] =>
  values.map(value => value.trim()).filter(Boolean);

export const listCellText = (values: string[]): string => {
  const present = presentItems(values);
  return present.length > 0 ? present.join(', ') : EMPTY_CELL;
};
